import { IconMaterialProps } from '@abyss/web/ui/IconMaterial';

export type IGridBuilderColumnType = {
  heading: string;
  field?: string;
  accessor?: string;
  width?: number;
  hidden?: boolean;
  isDate?: boolean;
  dateFormat?: string;
  disableSort?: boolean;
  disableResize?: boolean;
  link?: {
    url: string;
    appendValueInUrl?: boolean;
    icon?: IconMaterialProps['icon'];
    showValue?: boolean;
    openNewWindow?: boolean;
    appendPropertyName?: string;
    alignText?: 'left' | 'center' | 'right';
  };
  cell?: any;
  exportAsLink?: boolean | {
    exportCondition: ((args: any | undefined) => boolean);
  }
};

export interface IndividualGridAction {
  onClick: ({ action, row }) => void;
  checkDisabled: (row: any) => boolean;
  icon?: any | undefined;
  label?: any | undefined;
  isSeparated?: boolean | undefined;
}

export interface IGridBuilderProps {
  gridHeading?: string;
  gridName: string;
  gridOptionName: string;
  columns: IGridBuilderColumnType[];
  individualActions?: IndividualGridAction[] | IndividualGridAction | undefined;
  form: any;
  gridApiMethod?(formData?: any, page?: number, pageSize?: number): any;
  createNewButton?: {
    text: string;
    url: string;
    disabled?: boolean;
  };
  createBulkInsertButton?: {
    activateText: string;
    deActivateText: string;
    showEditButton?:boolean;
    showDeleteButton?:boolean;
    bulkActionEdit?: {
      text?: string;
      handler: (selectedRows: number[]) => void;
    };
    bulkActionDelete?: {
      text?: string;
      handler: (selectedRows: number[]) => void;
    };
  };
  filterButtons?: {
    filterButtonText?: string;
    clearFilterButtonText?: string;
  };
  onFilterClick?: (formData?: any) => any;
  onReset?:() => void;
  onDemandData?: boolean;
  hideFilter?: boolean;
  customHeaderButtons?: any[];
  showColumnVisibilityConfig?: boolean;
  showPagination?: boolean;
  showGlobalFilter?: boolean;
  showFilterDataset?: boolean;
  showTableSettings?: boolean;
  showDownloadButton?: boolean;
  highlightRowOnHover?: boolean;
  showFullscreenButton?: boolean;
  showBottomPagination?: boolean;
  showTopPagination?: boolean;
  showColumnSort?: boolean;
  showSelection?: boolean;
  setShowSelection?: any;
  serverSidePaging?: {
    usePaging: boolean,
    apiQueryOptions?: any,
  }
  customDownloadFileNameGetter?: (param?: any) => any;
  data?: Array<any>;
  customExport?: {
    removeFull?: boolean;
    removeFiltered?: boolean;
    custom?: {
      title: string;
      onClick: () => any;
    };
  };
  customCss?: any;
  removeCsvColumns?: string[];
  removeFilterColumns?: string[];
}

export interface IGridBuilderRef {
  ReloadGrid: (formData?: any) => any;
  GetData: () => Array<any>;
  SetGridColumns: (columns: any[]) => void;
  FilterGrid: (formData?: any) => any;
  GetSelectedData: () => Array<any>;
  Refetch: (formData?:any) => Promise<any>;
}

export interface ICustomHeaderButton {
  icon?: any;
  label: string;
  onClick?: (data?: any) => any;

  href?: string;
}

export const GridDefaultColumns = {
  CreatedDate: {
    field: 'createdDate',
    heading: 'Created Date',
    width: 180,
    isDate: true,
  },
  CreatedBy: {
    field: 'createdBy',
    heading: 'Created By',
    width: 140,
    // link: {
    //   url: '/crm/contact/',
    //   showValue: true,
    //   appendValueInUrl: true,
    //   openNewWindow: true,
    // },
  },
  UpdatedDate: {
    field: 'updatedDate',
    heading: 'Updated Date',
    width: 180,
    isDate: true,
  },
  UpdatedBy: {
    field: 'updatedBy',
    heading: 'Updated By',
    width: 140,
    // link: {
    //   url: '/crm/contact/',
    //   showValue: true,
    //   appendValueInUrl: true,
    //   openNewWindow: true,
    // },
  },
};
